export enum TipoArredondamentoEnum {
  Arredondar = 0,
  Truncar = 1,
}
